const getToken = () =>
  document.querySelector('[name="csrf-token"]').getAttribute('content');

export const apiUrl = process.env.API_URL;
export const csrfToken = getToken();
